import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { del, get, post, patch } from "../../api/api";

// Listar categorias
export const listarCategorias = async () => {
  return await get<IRespostaFuncao<any[]>>(`/categorias/obtem-categorias`);
};

// Criar categoria
export const criarCategoria = async (
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/categorias/cria-categoria`,
    payload
  );
};

// Atualizar categoria
export const atualizarCategoria = async (
  categoriaId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/categorias/${categoriaId}/atualiza-categoria`,
    payload
  );
};

// Deletar categoria
export const deletarCategoria = async (
  categoriaId: string
): Promise<IRespostaFuncao<any>> => {
  
  return await del<IRespostaFuncao<any>>(
    `/categorias/${categoriaId}/remove-categoria`,
  );
};
